import React from 'react';

const LayoutScopeContext = React.createContext({
    scope: null,
    hideLegacyMenus: false,
});

export const LayoutScopeProvider = LayoutScopeContext.Provider;

export function useLayoutScope() {
    return React.useContext(LayoutScopeContext);
}



// WEBPACK FOOTER //
// ./src/hoc/Layout/LayoutScopeContext.js